import { render, staticRenderFns } from "./ElearningQuestionAnswers.vue?vue&type=template&id=1d08e94a&scoped=true&"
import script from "./ElearningQuestionAnswers.vue?vue&type=script&lang=js&"
export * from "./ElearningQuestionAnswers.vue?vue&type=script&lang=js&"
import style0 from "./ElearningQuestionAnswers.vue?vue&type=style&index=0&id=1d08e94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08e94a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCardText,VCheckbox,VImg})
